<template>
  <layout-breadcrumb-cartao
    cartaoCustom
    titulo="Relatórios"
    :breadcrumb="bread"
    icone="file-text"
  >
    <div slot="cartao" v-if="!loading">
      <StepperRelatorio
        @indexAtual="trocarIndexAtual"
        :objetoEstiloCartao="{ 'min-height': '450px' }"
        :abas="abas"
        v-slot="{ indexAba }"
      >
        <SelecionarRelatorio
          @relatorio-selecionado="selecionarRelatorio"
          :listaRelatorios="listaRelatoriosFilter"
          key="0"
          v-if="indexAba === 0"
        />

        <keep-alive v-else :key="indexAba">
          <component
            ref="componente"
            :titulo="relatorioAtual ? relatorioAtual.descricao : ''"
            :is="componenteAtual"
            :objetoFiltro="objetoFiltro"
            @recuperar-objeto-filtro="recuperarObjetoFiltro"
            @habilitar-step="habilitarStep"
            @proxima-aba-filtro="proximaAbaFiltro"
          />
        </keep-alive>
      </StepperRelatorio>
    </div>
    <div slot="cartao" v-else>
      <StepperRelatorio
        :objetoEstiloCartao="{ 'min-height': '450px' }"
        :abas="abas"
      >
        <unicom-spinner
          style="
            min-height: 450px;
            display: flex;
            flex-flow: wrap column;
            justify-content: center;
          "
          :tamanhoLoading="62"
          :tamanhoLinha="7"
          :velocidade="0.5"
          :marginTopTexto="30"
          mensagem="Carregando..."
        />
      </StepperRelatorio>
    </div>
  </layout-breadcrumb-cartao>
</template>

<script>
import StepperRelatorio from "./shared/componentes/StepperRelatorio/StepperRelatorio";
import SelecionarRelatorio from "./shared/componentes/SelecionarRelatorio/SelecionarRelatorio";
import RelatoriosMixin from "./shared/RelatoriosMixin";

export default {
  components: {
    StepperRelatorio,
    SelecionarRelatorio
  },
  mixins: [RelatoriosMixin],
  data() {
    return {
      bread: [{ titulo: "Início", url: "/home" }, { titulo: "Relatórios" }]
    };
  }
};
</script>
